





















import { Vue, Component, Prop } from "vue-property-decorator";
import { IFiltersOptions } from "@/models/tables";

// Component
import Treeselect from "@riophae/vue-treeselect";

// Treeselect Styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    Treeselect
  }
})
export default class SelectMultiFilter extends Vue {
  @Prop({ required: true })
  public value!: string[];

  @Prop({ required: true })
  public options!: IFiltersOptions[];

  @Prop({ default: "" })
  public placeholder!: string;

  @Prop({ default: true })
  public alwaysOpen!: boolean;

  @Prop({ default: true })
  public isRequired!: boolean;

  @Prop({ default: false })
  public disabled!: boolean;

  public get selectedIds() {
    return this.value;
  }

  public set selectedIds(newSelectedIds: string[]) {
    this.$emit("input", newSelectedIds);
  }
}
